import Header from "./Header";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
// import "./Layout.scss";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MENU_LIST, ADMIN_TOP, HTML_TITLE } from "../../../utils/config";
import styles from "./Layout.module.scss";

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    // 画面スクロールを一番上に移動
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    // HTML Titleの設定
    if (ADMIN_TOP.url === location.pathname) {
      // 管理画面 - トップ
      document.title = `${ADMIN_TOP.title} | ${HTML_TITLE}`;
    } else {
      const current_menu = MENU_LIST.filter((menu) =>
        location.pathname.includes(menu.url)
      );
      if (current_menu.length > 0) {
        document.title = `${current_menu[0]?.title} | ${HTML_TITLE}`;
      }
    }
  }, [location]);
  return (
    <div className={`admin ${styles.container}`}>
      <Header />
      <Sidebar />
      <Outlet />
    </div>
  );
};

export default Layout;
